import { ReferenceData } from '@xplan-pension-switching/common';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAsync } from '../../helpers/Api/Api';

const CACHE_KEY = 'reference-data';

export const getReferenceDataAsync = async() : Promise<{ referenceData: ReferenceData }> => {
    const referenceData = await getAsync<ReferenceData>(`api/reference-data`);
    return { referenceData };
}

export const useReferenceDataQuery = () =>
    useSuspenseQuery({ queryKey: [CACHE_KEY], queryFn: () => getReferenceDataAsync() });
